export default __webpack_public_path__ + "static/b7-f3a149f8009755000eb69845bd8f10cf.png";